export default __webpack_public_path__ + "static/media/order-prepared.dae9610f.svg";